module.exports = __webpack_public_path__ + "static/media/audio-file.d3634127.svg";